import React from 'react';
import { Mail, Wrench } from 'lucide-react';

export default function MaintenancePage({ platformName = 'SeatifyAI', supportEmail = 'support@seatifyai.com' }) {
  return (
    <main className="min-h-screen flex items-center justify-center bg-slate-950 px-4 py-10 text-white">
      <section className="w-full max-w-xl text-center">
        <div className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-amber-400 text-slate-950 shadow-2xl shadow-amber-400/20">
          <Wrench size={36} />
        </div>
        <p className="mb-3 text-sm font-bold uppercase tracking-[0.22em] text-amber-300">
          Scheduled Maintenance
        </p>
        <h1 className="text-4xl font-extrabold leading-tight sm:text-5xl">
          {platformName} is getting a quick tune-up.
        </h1>
        <p className="mx-auto mt-5 max-w-md text-base leading-7 text-slate-300">
          We are temporarily offline while we improve the platform. Please check back soon.
        </p>
        {supportEmail && (
          <a
            href={`mailto:${supportEmail}`}
            className="mx-auto mt-8 inline-flex items-center justify-center gap-2 rounded-xl bg-white px-5 py-3 text-sm font-bold text-slate-950 transition-colors hover:bg-amber-100"
          >
            <Mail size={18} />
            Contact Support
          </a>
        )}
      </section>
    </main>
  );
}
